// Copyright (c) 2017 Deere & Company

export default [
    ['responsibleAccount', 'account'],
    ['responsibleAccount', 'industryIndicator'],
    ['responsibleAccount', 'location', 'city'],
    ['responsibleAccount', 'location', 'state'],
    ['responsibleAccount', 'name']
];



// WEBPACK FOOTER //
// ./src/claim/labor-rate-dealers/constants/filter-options.js